import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _wrapNativeSuper from "@babel/runtime-corejs2/helpers/esm/wrapNativeSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
export var HTTPError = /*#__PURE__*/function (_Error) {
  _inherits(HTTPError, _Error);

  var _super = _createSuper(HTTPError);

  function HTTPError(response) {
    var _this;

    _classCallCheck(this, HTTPError);

    _this = _super.call(this, "HTTP error status: ".concat(response.status));

    _defineProperty(_assertThisInitialized(_this), "response", void 0);

    _defineProperty(_assertThisInitialized(_this), "status", void 0);

    _this.response = response;
    _this.status = response.status;
    return _this;
  }

  return HTTPError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWJzL0hUVFBFcnJvci50cyJdLCJuYW1lcyI6WyJIVFRQRXJyb3IiLCJyZXNwb25zZSIsInN0YXR1cyIsIkVycm9yIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxXQUFhQSxTQUFiO0FBQUE7O0FBQUE7O0FBSUUscUJBQVlDLFFBQVosRUFBZ0M7QUFBQTs7QUFBQTs7QUFDOUIsMkRBQTRCQSxRQUFRLENBQUNDLE1BQXJDOztBQUQ4Qjs7QUFBQTs7QUFHOUIsVUFBS0QsUUFBTCxHQUFnQkEsUUFBaEI7QUFDQSxVQUFLQyxNQUFMLEdBQWNELFFBQVEsQ0FBQ0MsTUFBdkI7QUFKOEI7QUFLL0I7O0FBVEg7QUFBQSxpQ0FBK0JDLEtBQS9CIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNsYXNzIEhUVFBFcnJvciBleHRlbmRzIEVycm9yIHtcbiAgcHVibGljIHJlYWRvbmx5IHJlc3BvbnNlOiBSZXNwb25zZTtcbiAgcHVibGljIHJlYWRvbmx5IHN0YXR1czogbnVtYmVyO1xuXG4gIGNvbnN0cnVjdG9yKHJlc3BvbnNlOiBSZXNwb25zZSkge1xuICAgIHN1cGVyKGBIVFRQIGVycm9yIHN0YXR1czogJHtyZXNwb25zZS5zdGF0dXN9YCk7XG5cbiAgICB0aGlzLnJlc3BvbnNlID0gcmVzcG9uc2U7XG4gICAgdGhpcy5zdGF0dXMgPSByZXNwb25zZS5zdGF0dXM7XG4gIH1cbn1cbiJdfQ==